import go1 from "./go1.js";
import map from "./map.js";
import curry from "./curry.js";
export default curry(function each(f, iter) {
  return map(function (a) {
    return go1(f(a), function (_) {
      return a;
    });
  }, iter);
});